import { Contact } from '../interfaces/contact';

export class ContactModel implements Contact {
    CONTACTCODE: number;
    CUSTOMERCODE: string;
    Name1: string;
    Name2: string;
    LastName1: string;
    LastName2: string;
    Post: string;
    Phone: string;
    Fax: string;
    Email: string;
    Webpage: string;
    Notes: string;
    newContact?: boolean;

	constructor() { }
}
